/* script */
//
//
//
//
//
//
//
//
//
//

import { throttle } from 'lodash';
import BaseInput from './BaseInput.vue';

const __vue_script__ = {
    name: 'FpExtIdInput',

    components: { BaseInput },

    props: {
        label: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            default: null
        },
    },

    data() {
        return {
            errors: [],
            existing: new Set(),
            innerValue: undefined,
            ready: false,
            fpType: undefined,
            eid: undefined,
        };
    },

    async created() {
        this.fpType = this.$attrs?.fpType;
        this.eid = this.$attrs?.eid;
        if (!this.fpType && !this.eid) {
            console.error('[FpExtIdInput] Missing eid or fpType');
            return;
        }
        this.ready = true;
    },

    methods: {
        /** @type {(fpExtId: string) => Promise<boolean>} */
        async checkIfAlreadyUsed(fpExtId) {
            if (!fpExtId) {
                return false;
            }
            return this.$services.documents.isFpExtIdUsed(this.eid, this.fpType, fpExtId)
                .catch(err => {
                    console.error('[FpExtIdInput] Could not check if exists', err);
                    return false;
                });
        },

        /** @param {string} */
        onInput: throttle(async function(e) {
            const exists = await this.checkIfAlreadyUsed(e);
            if (exists) {
                this.errors = [this.$t('general.forms.fp_ext_id_error')];
                this.$emit('input', undefined);
            } else {
                this.errors = [];
                this.$emit('input', e);
            }
        }, 1000),
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',{staticClass:"fp-ext-id-input"},[_c('base-input',{attrs:{"errors":_vm.errors,"label":_vm.label,"name":_vm.name},on:{"input":_vm.onInput},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})],1):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "FpExtIdInput.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__